import {
  ESTADOS_TRAMITE_ENDPOINT,
  TIPOS_TRAMITE_ENDPOINT,
  TRAMITES_ENDPOINT,
  doPost,
  doGet,
  doPut,
  doDelete,
} from "../utils/api";

export async function listarTramites(consulta, token) {
  return await doGet(TRAMITES_ENDPOINT, consulta, null, token);
}

export async function buscarTramite(numero, token) {
  return await doGet(TRAMITES_ENDPOINT + `/${numero}`, null, null, token);
}

export async function actualizarTramite(tramite, token) {
  return await doPut(
    TRAMITES_ENDPOINT + `/${tramite.numero}`,
    tramite,
    null,
    null,
    token,
  );
}

export async function procesarTramite(tramite, estado, token) {
  const tipo = tramite.tipo.codigo;
  const message = {
    tipo,
    estado,
    tramite,
  };
  return await doPost(
    `${TRAMITES_ENDPOINT}/${tramite.numero}`,
    message,
    null,
    null,
    token,
  );
}

export async function listarTiposTramite(consulta, token) {
  return await doGet(TIPOS_TRAMITE_ENDPOINT, consulta, null, token);
}

export async function listarEstadosTramite(consulta, token) {
  return await doGet(ESTADOS_TRAMITE_ENDPOINT, consulta, null, token);
}

export async function iniciarTramite(tipo, CUIT, CURT, token) {
  return await doPut(
    TRAMITES_ENDPOINT,
    { tipo, CUIT, CURT },
    null,
    null,
    token,
  );
}

export async function cancelarTramite(numero, token) {
  return await doDelete(`${TRAMITES_ENDPOINT}/${numero}`, null, null, token);
}
